module.exports = __webpack_public_path__ + "img/salon_price.29ac77a2.png";